/**
 * @param {Array<number>} newValueIds
 * @param {Object} anyThreePromo
 * @param {Object} anyFivePromo
 * @returns {{ belongNeitherDbsOrSerumTests: number[], filteredNewValueIds: number[] }}
 */
import {
  TOTAL_TOX_TRIO,
  TOTAL_TOX_WITH_PFAS,
  TOTAL_TOX_WITH_OA,
  TOTAL_TOX_WITH_PFAS_OA,
  GUT_ZOOMERS,
  GUT4_ZOOMERS,
  GUT_PLUS_OA,
  GUT4_PLUS_OA,
  OA_NT,
  OA_MYCOTOX,
  SH_NT,
  GUT4_NT,
} from "./bestDealConstants";

export function getBelongNeitherDbsOrSerumTests(newValueIds, anyThreePromo, anyFivePromo) {
  let belongNeitherDbsOrSerumTests = [];
  let filteredNewValueIds = [...newValueIds];
  if (anyThreePromo || anyFivePromo) {
    belongNeitherDbsOrSerumTests = newValueIds.filter(id => anyThreePromo.bundleContentIds.includes(id));
    // total tox bundle - can form deal by itself, count as 1 test
    // and also can from 5for1000, count as 3 test
    if (
      belongNeitherDbsOrSerumTests.length === 3 &&
      belongNeitherDbsOrSerumTests.every(x => TOTAL_TOX_TRIO.includes(x))
    ) {
      belongNeitherDbsOrSerumTests = belongNeitherDbsOrSerumTests.filter(id => !TOTAL_TOX_TRIO.includes(id));
    }
    // VP-8072 total toxin can also form regular bundle with other tests
    // total tox + PFAS chemicals
    else if (belongNeitherDbsOrSerumTests.every(x => TOTAL_TOX_WITH_PFAS.includes(x))) {
      belongNeitherDbsOrSerumTests = belongNeitherDbsOrSerumTests.filter(id => !TOTAL_TOX_WITH_PFAS.includes(id));
    }
    // total tox + organic acid
    // VP-9240 add length check to avoid when select environmental toxin, mycotoxins and organic acid
    // 3 for 700 promo is not available
    else if (
      belongNeitherDbsOrSerumTests.length >= 4 &&
      belongNeitherDbsOrSerumTests.every(x => TOTAL_TOX_WITH_OA.includes(x))
    ) {
      belongNeitherDbsOrSerumTests = belongNeitherDbsOrSerumTests.filter(id => !TOTAL_TOX_WITH_OA.includes(id));
    }
    // total tox + PFAS chemicals + organic acid
    // VP-9240 add length check to avoid when select environmental toxin, mycotoxins and organic acid
    // 3 for 700 promo is not available
    else if (
      belongNeitherDbsOrSerumTests.length >= 5 &&
      belongNeitherDbsOrSerumTests.every(x => TOTAL_TOX_WITH_PFAS_OA.includes(x))
    ) {
      belongNeitherDbsOrSerumTests = belongNeitherDbsOrSerumTests.filter(id => !TOTAL_TOX_WITH_PFAS_OA.includes(id));
    }
    // gut zoomer + serum tests bundle e.g. gut zoomer + wheat zoomer
    else if (belongNeitherDbsOrSerumTests.every(x => GUT_ZOOMERS.includes(x))) {
      belongNeitherDbsOrSerumTests = belongNeitherDbsOrSerumTests.filter(id => !GUT_ZOOMERS.includes(id));
    }
    // gut zoomer 4.0 + serum tests bundle e.g. gut zoomer 4.0 + wheat zoomer
    else if (belongNeitherDbsOrSerumTests.every(x => GUT4_ZOOMERS.includes(x))) {
      belongNeitherDbsOrSerumTests = belongNeitherDbsOrSerumTests.filter(id => !GUT4_ZOOMERS.includes(id));
    }
    // gut zoomer + non serum tests bundle e.g. gut zoomer + organic acid
    else if (belongNeitherDbsOrSerumTests.every(x => GUT_PLUS_OA.includes(x))) {
      belongNeitherDbsOrSerumTests = belongNeitherDbsOrSerumTests.filter(id => !GUT_PLUS_OA.includes(id));
    }
    // gut zoomer 4.0 + non serum tests bundle e.g. gut zoomer 4.0 + organic acid
    else if (belongNeitherDbsOrSerumTests.every(x => GUT4_PLUS_OA.includes(x))) {
      belongNeitherDbsOrSerumTests = belongNeitherDbsOrSerumTests.filter(id => !GUT4_PLUS_OA.includes(id));
    }
    // Organic Acid + Neurotransmitters are both urine, but this bundle should belong to
    // normal test id pool
    else if (belongNeitherDbsOrSerumTests.every(x => OA_NT.includes(x))) {
      belongNeitherDbsOrSerumTests = belongNeitherDbsOrSerumTests.filter(id => !OA_NT.includes(id));
    }
    // Organic Acid + Mycotoxins are both urine, but this bundle should belong to
    // normal test id pool
    else if (belongNeitherDbsOrSerumTests.every(x => OA_MYCOTOX.includes(x))) {
      belongNeitherDbsOrSerumTests = belongNeitherDbsOrSerumTests.filter(id => !OA_MYCOTOX.includes(id));
    }
    // Salivary Hormones + Neurotransmitters can form a bundle and should be filtered out and belong to normal test id pool
    else if (belongNeitherDbsOrSerumTests.every(x => SH_NT.includes(x))) {
      belongNeitherDbsOrSerumTests = belongNeitherDbsOrSerumTests.filter(id => !SH_NT.includes(id));
    }
    // Gut Zoomer + Neurotransmitters bundle
    else if (belongNeitherDbsOrSerumTests.every(x => GUT4_NT.includes(x))) {
      belongNeitherDbsOrSerumTests = belongNeitherDbsOrSerumTests.filter(id => !GUT4_NT.includes(id));
    } 
    filteredNewValueIds = newValueIds.filter(id => !belongNeitherDbsOrSerumTests.includes(id));
  }
  return { belongNeitherDbsOrSerumTests, filteredNewValueIds };
}
